import React, { useMemo } from "react";
import styles from "./ManageGroupPage.module.scss";
import { useTranslation } from "react-i18next";
import { userCanAssignSomeLearningItemToGroup } from "../../state/calculations/permissions/userCan";
import Button from "../../components/basics/Button/Button";
import { Link } from "react-router-dom";
import { useSession } from "../../state/session";
import { useGroup } from "../../state/entities";
import useRoutes from "../../state/useRoutes";
import useGroupLearningItems from "../../state/queries/useGroupLearningItems";
import classnames from "classnames";
import { UnfinishedLearningAssignment } from "./ManageGroupPageLearningAssignments";
import { filterLearningItemsByKind } from "../../state/calculations/learningItemHelpers";

export default React.memo(function ManageGroupPageLearningPathAssignments( {uuid}: { uuid: string } ) {
  const { t } = useTranslation();
  const routes = useRoutes()
  const { user: currentUser } = useSession()
  const { group } = useGroup(uuid)

  const { groupLearningItems } = useGroupLearningItems(uuid)

  const groupLearningPathItems  = useMemo(() => filterLearningItemsByKind(groupLearningItems, ['learningPath']), [groupLearningItems])

  return (
    <section className={ styles.ManageGroupPageLearningPathAssignments }>
      <header>
        <h1>{ t('learning paths assignments') }</h1>
        { userCanAssignSomeLearningItemToGroup(currentUser, group) && (
          <Button
            small
            component={ Link } to={ routes.createGroupLearningAssignments.url({uuid, pathsOrCourses: '1'}) }
            preventScrollReset
          >
            { t('manage learning.cta assign learning item') }
          </Button>
        ) }
      </header>

      <main
        className={ classnames(styles.learningAssignmentsTable ) }
      >
        { groupLearningPathItems.map(( learningItem ) => (
          <UnfinishedLearningAssignment key={ learningItem.uuid } group={ group } learningItem={ learningItem }/>
        )) }

        { ! groupLearningPathItems.length &&
          <span className={ styles.empty }>{ t('no learning paths assignments found') }</span> }
      </main>
    </section>
  )
})
